export function YearCombobox({
  label,
  currentValue,
  onYearSelect,
  minYear,
  maxYear,
  placeholder = "Year",
  disabled = false,
  filterEnabled = true,
  onFilterEnabledChange,
}: {
  label: string;
  currentValue?: string;
  onYearSelect: (year: string | null) => void;
  minYear?: number;
  maxYear?: number;
  placeholder?: string;
  disabled?: boolean;
  filterEnabled?: boolean;
  onFilterEnabledChange?: (enabled: boolean) => void;
}) {
  const currentYear = new Date().getFullYear() + 1;
  const isInputDisabled = disabled || !filterEnabled;
  const years = Array.from({ length: currentYear - 1979 }, (_, i) => String(currentYear - i))
    .filter((year) => {
      const numeric = Number(year);
      if (minYear && numeric < minYear) return false;
      if (maxYear && numeric > maxYear) return false;
      return true;
    });

  return (
    <div className="mt-1">
      <label className={`flex items-center gap-1.5 text-sm font-medium text-black ${onFilterEnabledChange ? "cursor-pointer" : ""}`}>
        {onFilterEnabledChange && (
          <input
            type="checkbox"
            checked={filterEnabled}
            onChange={(event) => onFilterEnabledChange(event.target.checked)}
            disabled={disabled}
            className="h-3.5 w-3.5 rounded border-gray-300 text-primary-600 focus:ring-primary-500 disabled:cursor-not-allowed disabled:opacity-50"
          />
        )}
        <span>{label}</span>
      </label>
      <select
        value={currentValue ?? ""}
        disabled={isInputDisabled}
        onChange={(e) => onYearSelect(e.target.value || null)}
        className="mt-1 w-full rounded-md border border-gray-400 px-2 py-2 text-sm disabled:bg-gray-100"
      >
        <option value="">{placeholder}</option>
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </div>
  );
}
